import { FC } from 'react';
import { ActionModal, ElementsForm, ModalActionProps } from '../../UI';
import { useTranslation } from 'react-i18next';
import { NoteReceivable } from '../../generated/graphql';
import { getNoteReceivableValue, getUpdateNoteReceivableServiceInputFromForm } from '../util';
import { useUpdateNoteReceivableValueService } from '../service';
import { useEditNoteReceivableForm } from '../hooks';
import { NoteReceivableEstimatedValueInput } from './NoteReceivableEstimatedValueInput';

export type EditNoteReceivableBalanceModalProps = Pick<ModalActionProps, 'onCancel' | 'isLoading' | 'onSave'> & {
  noteReceivable: NoteReceivable;
  afterUpdate?: (noteReceivable: NoteReceivable) => Promise<void>;
};

export const EditNoteReceivableBalanceModal: FC<EditNoteReceivableBalanceModalProps> = ({
  onSave,
  isLoading,
  onCancel,
  noteReceivable,
  afterUpdate,
}) => {
  const { t: tCommon } = useTranslation('common');
  const { updateNoteReceivableValueService } = useUpdateNoteReceivableValueService();

  const formReturn = useEditNoteReceivableForm({
    defaultValues: { estimatedValue: getNoteReceivableValue(noteReceivable)?.value / 100 || 0 },
    handleSubmit: async ({ formValues }) => {
      await updateNoteReceivableValueService.mutateAsync(
        getUpdateNoteReceivableServiceInputFromForm({
          formValues,
          householdID: noteReceivable.householdID,
          noteReceivableID: noteReceivable.id,
          changeToken: noteReceivable.changeToken,
          valueDataPointGroupID: noteReceivable.value.id,
        })
      );
      await afterUpdate?.(noteReceivable);
    },
    saveOnChange: false,
  });
  return (
    <ActionModal title={noteReceivable.name} subtitle={tCommon('note-receivable')}>
      {(action) => (
        <ElementsForm useFormReturn={formReturn}>
          <NoteReceivableEstimatedValueInput />
          {action({
            onSave,
            isLoading: isLoading || updateNoteReceivableValueService.isLoading,
            onCancel,
          })}
        </ElementsForm>
      )}
    </ActionModal>
  );
};
